export enum EventInvitationJobStatus {
  UNPROCESSED = 'UNPROCESSED',
  PROCESSING = 'PROCESSING',
  PROCESSED = 'PROCESSED',
  FAILED = 'FAILED'
}

export interface EventInvitationProcessingJob {
  jobId: number;
  jobStatus: EventInvitationJobStatus;
  numInvitees: number;
}
